export const WAREHOUSE_STATUS_INACTIVE = 0
export const WAREHOUSE_STATUS_ACTIVE = 1

export const WAREHOUSE_STATUS_NAMES = {
  0: 'Inactive',
  1: 'Active',
}

export const WAREHOUSE_STATUS_DROPDOWN_OPTIONS = [
  { value: WAREHOUSE_STATUS_ACTIVE, label: WAREHOUSE_STATUS_NAMES[WAREHOUSE_STATUS_ACTIVE] },
  { value: WAREHOUSE_STATUS_INACTIVE, label: WAREHOUSE_STATUS_NAMES[WAREHOUSE_STATUS_INACTIVE] },
]

export const WAREHOUSE_AUTO_ISSUANCE_APPROVAL_NAMES = {
  0: 'No',
  1: 'Yes',
}

export const WAREHOUSE_AUTO_ISSUANCE_APPROVAL_OPTIONS = [
  { value: 1, label: WAREHOUSE_AUTO_ISSUANCE_APPROVAL_NAMES[1] },
  { value: 0, label: WAREHOUSE_AUTO_ISSUANCE_APPROVAL_NAMES[0] },
]

export const WarehouseModel = {
  id: 0,
  branch_id: 0,
  branch: { name: '' },
  code: 'Auto Generated',
  name: '',
  description: '',
  status: 1,
  auto_issuance_approval: 0,
  warehouse_location_id: '',
  warehouse_location: { name: '' },
}
